"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BackgroundControls = void 0;
const config_1 = require("../../../config");
const UiElements_1 = require("../../ui/UiElements");
const imageOptions = [
    { name: config_1.config.resources.images.background[0].name },
    { name: config_1.config.resources.images.background[1].name }
];
class BackgroundControls {
    constructor(parentEl) {
        this.previousColors = [];
        if (!parentEl) {
            throw new Error("Parent element (backgroundControl) is undefined");
        }
        this.defaultBackground = {
            type: "COLOR" /* COLOR */,
            color: config_1.config.webgl.backgroundColor,
            texture: imageOptions[0].name
        };
        this.selectedImage = this.defaultBackground.texture;
        const title = this.createTitle();
        const element = this.createElement();
        parentEl.append(title.domEl, element.domEl);
    }
    dispose() {
        delete this.backgroundType;
        delete this.backgroundImageA;
        delete this.backgroundImageB;
        delete this.backgroundImages;
    }
    refreshBackgroundUI() {
        var _a, _b, _c, _d, _e;
        const type = (_a = this.backgroundType) === null || _a === void 0 ? void 0 : _a.getValue();
        const color = type === "COLOR" /* COLOR */ ? 'block' : 'none';
        const texture = type === "TEXTURE" /* TEXTURE */ ? 'flex' : 'none';
        (_b = this.backgroundColorContainer) === null || _b === void 0 ? void 0 : _b.setStyle({ 'display': color });
        (_c = this.backgroundImages) === null || _c === void 0 ? void 0 : _c.setStyle({ 'display': texture });
        // Selected option
        for (const option of (_d = this.backgroundType) === null || _d === void 0 ? void 0 : _d.domEl.children) {
            option.removeAttribute('selected');
            if (option.value === type) {
                option.setAttribute('selected', '');
            }
        }
        // Selected image
        for (const image of (_e = this.backgroundImages) === null || _e === void 0 ? void 0 : _e.domEl.children) {
            const imgSrc = image.getAttribute('src');
            const selectedImage = this.selectedImage;
            image.style.borderColor = 'rgba(255, 255, 255, 0)';
            if (imgSrc === selectedImage) {
                image.style.borderColor = 'rgba(0, 0, 0, 255)';
            }
        }
    }
    createTitle() {
        const title = new UiElements_1.DivEl()
            .setClass('module-title')
            .setId('backgroundTitle')
            .addAttribute('data-i18n-key', 'BACKGROUND');
        return title;
    }
    createElement() {
        this.backgroundType = this.createSelectDiv();
        this.backgroundColorContainer = this.createColorContainer();
        this.backgroundImages = this.createImagesDiv();
        return new UiElements_1.DivEl()
            .setId('backgroundControls')
            .addChild(this.backgroundType)
            .addChild(this.backgroundColorContainer)
            .addChild(this.backgroundImages);
    }
    createSelectDiv() {
        return new UiElements_1.SelectEl()
            .setValue(this.defaultBackground.type)
            .setOptions({
            'UNSPECIFIED': '',
            'COLOR': 'COLOR',
            'TEXTURE': 'TEXTURE'
        }, this.defaultBackground.type)
            .setClass('form-select');
    }
    createColorContainer() {
        const containerEl = new UiElements_1.DivEl().setId('colorSelectContainer');
        this.colorPicker = new UiElements_1.ColorEl()
            .setValue(this.defaultBackground.color)
            .setClass('color-picker')
            .setId('colorPicker');
        this.colorPickerBtn = this.createColorPickerBtn();
        const separatorEl = document.createElement('div');
        separatorEl.classList.add('separator');
        containerEl.domEl.append(this.colorPicker.domEl, this.colorPickerBtn, separatorEl);
        return containerEl;
    }
    createColorPickerBtn() {
        return new UiElements_1.ButtonEl()
            .setId('colorPickerBtn')
            .setClass('left-bound')
            .addAttribute('data-i18n-attr', 'data-title=COLOR_PICKER')
            .addChild(new UiElements_1.IconEl('color-picker'))
            .domEl;
    }
    createImagesDiv() {
        this.backgroundImageA = new UiElements_1.ImageEl(imageOptions[0].name);
        this.backgroundImageB = new UiElements_1.ImageEl(imageOptions[1].name);
        return new UiElements_1.DivEl()
            .setId('backgroundImageContainer')
            .addChild(this.backgroundImageA)
            .addChild(this.backgroundImageB);
    }
}
exports.BackgroundControls = BackgroundControls;
